import { useEffect, useState } from "react";
import { useLoading } from "../context/LoadingContext";
import "./ProgressBar.css";

function ProgressBar() {
    const { isLoading } = useLoading();
    const [progress, setProgress] = useState(0);
    const [visible, setVisible] = useState(true);

    const RADIUS = 54;
    const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

    useEffect(() => {
        if (isLoading) {
            setVisible(true);
            setProgress(0);

            const interval = setInterval(() => {
                setProgress((prev) => {
                    if (prev >= 90) return prev;
                    return prev + Math.random() * 10;
                });
            }, 200);

            return () => clearInterval(interval);
        } else {
            setProgress(100);

            const timeout = setTimeout(() => {
                setVisible(false);
            }, 400);

            return () => clearTimeout(timeout);
        }
    }, [isLoading]);

    if (!visible && !isLoading) return null;

    return (
        <>
            {/* Full screen overlay */}
            <div className={`loading-overlay ${!isLoading ? "fade-out" : ""}`}>
                <div className="loading-content">

                    {/* Circular Progress */}
                    <div className="circular-progress-wrapper">
                        <svg
                            className="circular-progress"
                            width="120"
                            height="120"
                        >
                            <circle
                                className="circular-bg"
                                cx="60"
                                cy="60"
                                r={RADIUS}
                            />
                            <circle
                                className="circular-bar"
                                cx="60"
                                cy="60"
                                r={RADIUS}
                                style={{
                                    strokeDasharray: CIRCUMFERENCE,
                                    strokeDashoffset:
                                        CIRCUMFERENCE * (1 - progress / 100),
                                }}
                            />
                        </svg>

                        <div className="progress-text">
                            {Math.round(progress)}%
                        </div>
                    </div>

                    <h2 className="loading-text">Loading...</h2>
                </div>
            </div>
        </>
    );
}

export default ProgressBar;
